import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyA1LQEcE58AkN9OeK28JxYucVYtLGAWrZc",
    authDomain: "jackson-egress-windows.firebaseapp.com",
    databaseURL: "https://jackson-egress-windows-default-rtdb.firebaseio.com",
    projectId: "jackson-egress-windows",
    storageBucket: "jackson-egress-windows.appspot.com",
    messagingSenderId: "280363051462",
    appId: "1:280363051462:web:a75a629cd2512c116d6ac7"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();

export { firebase, firestore };
